<template>
  <section v-on:click="sectionClicked" class="features">
    <div class="cnt subscriptionCnt">
      <div class="sectionHeader" v-if="section.title[lang] || section.descriptions[lang]">
        <h4 class="sectionTitle" v-if="section.title[lang]">{{section.title[lang]}}</h4>
        <p class="sectionDesc" v-if="section.descriptions[lang]">{{section.descriptions[lang]}}</p>
      </div>
      <div class="subscription">
        <form v-on:submit.prevent="handleSubmit">
          <div class="fieldGroup" :class="{hasError: hasError || invalid}">
            <div class="fieldCnt">
              <input type="text" class="field" :placeholder="placeholder"
                v-model="email" v-on:input="hasError = false; invalid = false;">
              <button class="btn primary" type="submit"><span>Subscribe</span></button>
            </div>
            <template v-if="hasError">
              <div class="fieldError" v-if="lang === 'id'">Mohon isi alamat email kamu</div>
              <div class="fieldError" v-else>Please input your email address</div>
            </template>
            <template v-else-if="invalid">
              <div class="fieldError" v-if="lang === 'id'">Alamat email tidak valid</div>
              <div class="fieldError" v-else>Invalid email address</div>
            </template>
          </div>
        </form>
      </div>
    </div>
    <ThankYou ref="thankYou"/>
  </section>
</template>

<script>
import ThankYou from '@/components/ThankYou.vue';

export default {
  name: 'subscription',
  props: ['section'],
  components: { ThankYou },
  data() {
    return {
      placeholder: '',
      email: '',
      hasError: false,
      invalid: false,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
    handleSubmit() {
      if (!this.email || this.email.trim() === '') {
        this.hasError = true;
        return;
      }

      if (!this.email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
        this.invalid = true;
        return;
      }

      this.loading = true;
      this.$refs.thankYou.open({
        loading: true,
        title: this.section.config.thankYouTitle[this.lang],
        desc: this.section.config.thankYouDesc[this.lang],
      });
      this.$http.post(this.$config.uri('user/subscribe'), {
        title: this.section.title,
        descriptions: this.section.descriptions,
        emailVerification: this.section.config.emailVerification,
        email: this.email,
        lang: this.lang,
      }).then((r) => {
        this.loading = false;
        this.$refs.thankYou.stopLoading();
        this.email = '';
      });
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
    this.placeholder = this.lang === 'id' ? 'Alamat email kamu...' : 'Your email address...';
  },
};
</script>

<style scoped lang="scss">
.subscriptionCnt{
  padding: 20px 0;
}
.sectionHeader{
  padding: 0 0 20px;
  .sectionTitle{
    // color: #fff;
    font-size: 34px;
    @media (max-width: 640px) {
      font-size: 26px;
    }
  }
  .sectionDesc{
    // color: #fff;
  }
}
.subscription{
  max-width: 640px;
  margin: 0 auto;
  .fieldError{
    margin-left: 20px;
  }
  .fieldCnt{
    position: relative;
    .field{
      padding: 12px 24px;
      border-radius: 60px;
      font-size: 20px;
      @media (max-width: 640px) {
        font-size: 16px;
      }
    }
    button{
      position: absolute;
      right: 4px; top: 4px; bottom: 4px;
      height: auto;
      padding: 0 20px;
      line-height: 1;
      font-weight: 500;
      border-radius: 50px;
      text-transform: uppercase;
      @media (max-width: 640px) {
        font-size: 15px;
      }
    }
  }
}
</style>
